var _defs, _circle, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoLinkedin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "15.17mm",
    height: "15.77mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 43 44.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#Degradado_sin_nombre);isolation:isolate;opacity:.8;}.cls-3{fill:#d11664;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre",
    cx: 21.5,
    cy: 22.81,
    fx: 21.5,
    fy: 22.81,
    r: 21.5,
    gradientTransform: "translate(0 46) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#7474a4",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#d8d8e5",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 21.5,
    cy: 23.19,
    r: 21.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m30.88,14.62C30.88,6.55,24.33,0,16.26,0S1.64,6.55,1.64,14.62c0,7.3,5.35,13.35,12.34,14.44v-10.22h-3.71v-4.23h3.71v-3.22c0-3.66,2.18-5.69,5.52-5.69,1.6,0,3.27.29,3.27.29v3.6h-1.84c-1.82,0-2.38,1.13-2.38,2.28v2.74h4.06l-.65,4.23h-3.41v10.22c6.99-1.1,12.34-7.15,12.34-14.44h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m21.95,18.85l.65-4.23h-4.06v-2.74c0-1.16.57-2.28,2.38-2.28h1.84v-3.6s-1.67-.29-3.27-.29c-3.34,0-5.52,2.02-5.52,5.69v3.22h-3.71v4.23h3.71v10.22c.74.12,1.51.18,2.28.18s1.54-.06,2.28-.18v-10.22h3.42Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 16.26,
    cy: 14.63,
    r: 14.62
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m10.13,11.91h2.83v9.1h-2.83v-9.1Zm1.42-4.52c.91,0,1.64.73,1.64,1.64s-.73,1.64-1.64,1.64-1.64-.74-1.64-1.64.73-1.64,1.64-1.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m14.73,11.91h2.71v1.24h.04c.38-.72,1.3-1.47,2.68-1.47,2.86,0,3.39,1.88,3.39,4.33v4.99h-2.83v-4.42c0-1.06-.02-2.41-1.47-2.41s-1.7,1.15-1.7,2.34v4.5h-2.83v-9.1h.01Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLinkedin);
export default __webpack_public_path__ + "static/media/logoLinkedin.87f701627def79404419d20257b6c8ee.svg";
export { ForwardRef as ReactComponent };